import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({ name: "sanitizeHtml", standalone: true, pure: true })
export class SanitizeHtmlPipe implements PipeTransform {
  private readonly domSanitizer: DomSanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(value ?? "");
  }
}
